import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface ICancelParkingSubscriptionForUserVars {
  login: string
  parkingSubscription: ID
  days?: string[]
  comment: string
  notify: boolean
}

export interface ICancelParkingSubscriptionForUserData {
  cancelParkingSubscriptionForUser: IQueryBasicData
}

export const CANCEL_PARKING_SUBSCRIPTION_FOR_USER = gql`
  mutation cancelParkingSubscriptionForUser(
    $login: String!
    $parkingSubscription: ID!
    $days: [DateTime!]
    $comment: String!
    $notify: Boolean
  ) {
    cancelParkingSubscriptionForUser(
      login: $login
      parking_subscription: $parkingSubscription
      days: $days
      comment: $comment
      notify: $notify
    ) {
      status
      code
      error
      message
    }
  }
`
